var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card"},[_c('img',{attrs:{"src":_vm.image,"alt":"Imagem Card"}}),_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }